import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "../pages/auth/loginPage";
import SignUpPage from "../pages/auth/signUpPage";
import PageNotFound from "../pages/pageNotFound";
import DashboardPage from "../pages/dashboard";
import GuestGuard from "../guards/GuestGuard";
import AuthGuard from "../guards/AuthGuard";
import UserList from "../pages/user/list";
import UserEdit from "../pages/user/edit";
import AddUser from "../pages/user/add";
import ProfileCurrent from "../pages/profile";
import ProfilePublicPage from "../pages/profile/public";
import QrDownload from "../pages/user/qr/donwload";
import RealTime from "../pages/report/realtime";
import CartExport from "../pages/cart/export";
import WishlistExport from "../pages/wishlist/export";
import ProductsExport from "../pages/products/export";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/auth/login"
          element={
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          }
        />
        <Route
          path="/auth/sign-up"
          element={
            <GuestGuard>
              <SignUpPage />
            </GuestGuard>
          }
        />
        <Route
          path="/"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/me"
          element={
            <AuthGuard>
              <ProfileCurrent />
            </AuthGuard>
          }
        />
        <Route
          path="/users/add"
          element={
            <AuthGuard>
              <AddUser />
            </AuthGuard>
          }
        />
        <Route
          path="/users/list"
          element={
            <AuthGuard>
              <UserList />
            </AuthGuard>
          }
        />
        <Route
          path="/users/:id"
          element={
            <AuthGuard>
              <UserEdit />
            </AuthGuard>
          }
        />
        <Route
          path="/users/download/qr"
          element={
            <AuthGuard>
              <QrDownload/>
            </AuthGuard>
          }
        />
        <Route
          path="/users/:id/edit"
          element={
            <AuthGuard>
              <UserEdit />
            </AuthGuard>
          }
        />
        <Route
          path="/position/list"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/position/id"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/position/edit"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/position/eid"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/profile/:username"
          element={
              <ProfilePublicPage />
          }
        />
        {/*<Route*/}
        {/*  path="/report/realtime"*/}
        {/*  element={*/}
        {/*    <AuthGuard>*/}
        {/*      <RealTime />*/}
        {/*    </AuthGuard>*/}
        {/*  }*/}
        {/*/>*/}
        <Route
          path="/carts/export"
          element={
            <AuthGuard>
              <CartExport />
            </AuthGuard>
          }
        />
        <Route
          path="/wishlists/export"
          element={
            <AuthGuard>
              <WishlistExport />
            </AuthGuard>
          }
        />
        <Route
          path="/products/export"
          element={
            <AuthGuard>
              <ProductsExport />
            </AuthGuard>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
